import AboutUsRightPart from '../../../components/AboutUs/AboutUsRightPart/AboutUsRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(AboutUsRightPart);
